// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"w--z","button":"x--z","disabled":"y--z","creditCard":"z--z","wrapper":"A--z"};